import React, { useState, useEffect } from 'react';
import { Table, Select, Button, Space, message } from 'antd';
import { customBaseUrl, httpGet } from '../../../store/http';
import { hideLoader, showLoader } from '../../../utils/loader';
import Swal from 'sweetalert2';

const { Option } = Select;

const PricingUsageStatistics = () => {
  const [statistics, setStatistics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProductCode, setSelectedProductCode] = useState(null);

  const fetchProducts = async () => {
    try {
      const response = await httpGet(`${customBaseUrl.integUrl}/api/v1/products?page=0&size=1000`); // Fetch all products
      if (response.status) {
        setProducts(response.data.content);
      } else {
        Swal.fire('Error', response.message || 'Failed to fetch products', 'error');
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      Swal.fire('Error', 'An error occurred while fetching products', 'error');
    }
  };

  const fetchStatistics = async () => {
    if (!selectedProductCode) {
      message.warning('Please select a product.');
      return;
    }

    setLoading(true);
    showLoader();
    try {
      const response = await httpGet(`${customBaseUrl.integUrl}/api/v1/pricing/usage/${selectedProductCode}`);
      if (response.status) {
        setStatistics(response.data); // Assuming response.data is an array of statistics items
      } else {
        Swal.fire('Error', response.message || 'Failed to fetch usage statistics', 'error');
      }
    } catch (error) {
      console.error('Error fetching usage statistics:', error);
      Swal.fire('Error', 'An error occurred while fetching usage statistics', 'error');
    } finally {
      hideLoader();
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const columns = [
    {
      title: 'Statistic Field 1', // Replace with actual statistic fields
      dataIndex: 'field1',
      key: 'field1',
    },
    {
      title: 'Statistic Field 2', // Replace with actual statistic fields
      dataIndex: 'field2',
      key: 'field2',
    },
    // Add more columns as per the actual statistics structure
  ];

  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Select
          placeholder="Select Product"
          style={{ width: 200 }}
          onChange={(value) => setSelectedProductCode(value)}
        >
          {products.map(product => (
            <Option key={product.productCode} value={product.productCode}>
              {product.productName}
            </Option>
          ))}
        </Select>
        <Button type="primary" onClick={fetchStatistics}>
          Generate Statistics
        </Button>
      </Space>
      <Table
        columns={columns}
        dataSource={statistics}
        rowKey={(record, index) => index} // Assuming no unique key in statistics data
        loading={loading}
        pagination={false} // Statistics might not need pagination
      />
    </div>
  );
};

export default PricingUsageStatistics;
